import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
// Request permissions and get FCM token
export async function initPush() {
  // Skip FirebaseMessaging when running on web (browser)
  if (Capacitor.getPlatform() === 'web') {
    console.log('⚠️ Skipping push setup — running in browser, not Android');
    return;
  }

  const permStatus = await FirebaseMessaging.requestPermissions();

  if (permStatus.receive === 'granted') {
    const token = await FirebaseMessaging.getToken();
    localStorage.setItem('fcmtoken', token.token)

    // Listen for messages
    FirebaseMessaging.addListener('notificationReceived', (notification) => {
        console.log('Notification received:'+ notification);
    });
  } else {
    console.log('Push permission not granted');
  }
}
